import React from 'react';
import { cx } from '../../styles';

interface SubTabItem {
  key: string;
  label: string;
}

interface SubTabNavProps {
  tabs: SubTabItem[];
  activeTab: string;
  onTabChange: (tabKey: string) => void;
  className?: string;
}

/**
 * Unified subtab navigation component
 * Provides consistent styling for all chart subtabs
 */
const SubTabNav: React.FC<SubTabNavProps> = ({ 
  tabs, 
  activeTab, 
  onTabChange, 
  className = '' 
}) => {
  return (
    <div className={cx('flex border-b border-gray-200 dark:border-theme-border-primary mb-3 sm:mb-6', className)}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={cx(
            'px-3 sm:px-6 py-2 sm:py-3 text-xs sm:text-sm font-medium border-b-2 transition-colors',
            activeTab === tab.key
              ? 'text-blue-600 dark:text-blue-400 border-blue-600 dark:border-blue-400'
              : 'text-gray-500 dark:text-gray-300 border-transparent hover:text-gray-700 dark:hover:text-gray-100 hover:border-gray-300 dark:hover:border-gray-500'
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default SubTabNav;
